import { get } from './index';

export const getCurrentUserInfo = async (apiVersion = 'v1') => {
  // Default v1 keeps legacy behavior; pass 'v3' from redesign screens.
  return get(`/api/${apiVersion}/registrations/`, {
  });
};
